import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Library, SquarePen } from 'lucide-react';
import { useNewChat } from '../hooks/useNewChat';

/** The open chat's title, with the prompt library and a new chat one click away. */
export function ChatHeader({ title, onOpenLibrary }: { title: string; onOpenLibrary: () => void }) {
  const newChat = useNewChat();
  return (
    <Stack direction="row" sx={barSx}>
      <Typography variant="h4" component="h1" noWrap sx={{ flexGrow: 1, minWidth: 0, fontSize: '0.875rem' }}>{title}</Typography>
      <Button size="small" variant="outlined" startIcon={<Library size={14} strokeWidth={1.75} />} onClick={onOpenLibrary} sx={libraryButtonSx}>
        Prompt library
      </Button>
      <Button size="small" startIcon={<SquarePen size={14} strokeWidth={1.75} />} onClick={newChat} sx={{ color: 'text.secondary', '&:hover': { color: 'text.primary', bgcolor: 'surface.subtle' } }}>
        New chat
      </Button>
    </Stack>
  );
}

const barSx = {
  alignItems: 'center',
  gap: 1,
  px: { xs: 2, md: 3 },
  minHeight: 52,
  flexShrink: 0,
  bgcolor: 'background.paper',
  borderBottom: 1,
  borderColor: 'divider',
} as const;

const libraryButtonSx = {
  flexShrink: 0,
  color: 'text.primary',
  borderColor: 'divider',
  '&:hover': { bgcolor: 'surface.subtle', borderColor: 'surface.border' },
} as const;
